// Esperanto translations
export const eo: Record<string, string> = {
  'menu.dashboard': 'Stirpanelo',
  'menu.customers': 'Klientoj',
  'menu.products': 'Produktoj',
  'menu.users': 'Uzantoj',
  'menu.settings': 'Agordoj',
  'menu.logout': 'Elsaluti',
  'dashboard.title': 'Stirpanelo',
  'dashboard.newOrder': 'Nova Mendo',
  'order.title': 'Nova Mendo',
  'order.customer': 'Kliento',
  'order.products': 'Produktoj',
  'order.total': 'Sumo',
  'users.title': 'Uzantoj',
  'users.name': 'Nomo',
  'users.email': 'Retpoŝto',
  'common.yes': 'Jes',
  'common.no': 'Ne',
  'common.cancel': 'Nuligi',
  'common.save': 'Konservi',
  'common.search': 'Serĉi',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Ensaluti',
  'login.welcome': 'Bonvenon, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Retpoŝto',
  'signup.phone': 'Telefono',
  'menu.reportsAndAccounting': 'Raportoj kaj Kontado',
  'menu.systemAndCommunication': 'Sistemo kaj Komunikado',
};